import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { AISearchRepository } from '../../service/ai-search.repository.interface'
import { type ApiTransferQueryRequest, TransferQuery } from '@/infrastructure/api-functions/interface/transfer-query.interface';

export const TransferQueryDTO = Symbol('TransferQueryDTO');

export interface TransferQueryDTO {
    fetch: AISearchRepository['transferQuery'];
}

@injectable()
export class TransferQueryDTOImpl implements TransferQueryDTO {
    constructor(
        @inject(TransferQuery)
        private readonly _transferQueryApi: TransferQuery,
    ) { }

    async fetch(value: ApiTransferQueryRequest) {
        const res = await this._transferQueryApi.transferQuery(value);

        return res;
    }
}